import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { Search, Menu, X, Sparkles } from 'lucide-react';

const ModernHeader = ({ onSearchToggle }) => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled 
        ? 'glass-strong backdrop-blur-xl border-b border-white/10 shadow-lg' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo officiel Bozzam */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/logo-bozzam.jpg" 
              alt="Bozzam" 
              className="h-20 w-auto group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Navigation Desktop */}
          <nav className="hidden lg:flex items-center space-x-1">
            {[
              { path: '/', label: 'Accueil' },
              { path: '/articles', label: 'Articles' },
              { path: '/simulateurs', label: 'Simulateurs' },
              { path: '/application', label: 'Application Bozzam' }
            ].map((item) => (
              <Link 
                key={item.path}
                to={item.path} 
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-white/10 ${
                  isActive(item.path) 
                    ? 'text-blue-600 bg-blue-50/50' 
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Actions Desktop */}
          <div className="hidden lg:flex items-center space-x-3">
            <Button
              variant="ghost"
              size="sm"
              onClick={onSearchToggle}
              className="text-gray-600 hover:text-gray-900 hover:bg-white/10 rounded-lg p-2"
            >
              <Search className="h-5 w-5" />
            </Button>
            
            <Button 
              className="btn-modern gradient-primary text-white px-6 py-2 rounded-xl font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
              onClick={() => window.open(process.env.REACT_APP_BOZZAM_APP_URL, '_blank')}
            >
              Lancer mon entreprise
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-600 hover:text-gray-900 p-2"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden glass-strong backdrop-blur-xl border-t border-white/10 py-6 animate-fadeIn">
            <div className="flex flex-col space-y-3">
              {[
                { path: '/', label: 'Accueil' },
                { path: '/articles', label: 'Articles' },
                { path: '/simulateurs', label: 'Simulateurs' },
                { path: '/application', label: 'Application Bozzam' }
              ].map((item) => (
                <Link 
                  key={item.path}
                  to={item.path} 
                  className={`px-4 py-3 text-lg font-medium transition-colors rounded-lg ${
                    isActive(item.path)
                      ? 'text-blue-600 bg-blue-50/50'
                      : 'text-gray-700 hover:text-gray-900 hover:bg-white/10'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              
              <div className="pt-4 border-t border-white/10">
                <Button
                  size="sm"
                  onClick={onSearchToggle}
                  className="w-full justify-start text-gray-600 hover:text-gray-900 mb-3 hover:bg-white/10"
                  variant="ghost"
                >
                  <Search className="h-5 w-5 mr-3" />
                  Rechercher
                </Button>
                
                <Button 
                  className="btn-modern gradient-primary text-white w-full py-3 rounded-xl font-semibold"
                  onClick={() => {
                    window.open(process.env.REACT_APP_BOZZAM_APP_URL, '_blank');
                    setMobileMenuOpen(false);
                  }}
                >
                  Lancer mon entreprise
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default ModernHeader;